import { bodySecondaryFontSize, bodySecondaryLineHeight, Spacing } from 'atomic'
import { textMaxLines } from 'atomic/legacy/obj.mixin'
import styled from 'styled-components'

export const ArticleListItemBodyWrapperStyled = styled.div`
  ${textMaxLines(3, bodySecondaryLineHeight * parseInt(bodySecondaryFontSize, 0))};
  margin-bottom: ${Spacing.Small};
`
